import { queryOptions } from '@tanstack/react-query';

import { practiceMemberApi } from './practice-member.api';

export const queryKeys = {
    all: ['practice-members'] as const,
    me: () => [...queryKeys.all, 'me'] as const,
    preferences: () => [...queryKeys.all, 'preferences'] as const,
    insights: () => [...queryKeys.all, 'insights'] as const,
    licenses: () => [...queryKeys.all, 'licenses'] as const,
};

export function practiceMemberOptions() {
    return queryOptions({
        queryKey: queryKeys.me(),
        queryFn: ({ signal }) => practiceMemberApi.get(signal),
    });
}

export function preferencesOptions() {
    return queryOptions({
        queryKey: queryKeys.preferences(),
        queryFn: ({ signal }) => practiceMemberApi.getPreferences(signal),
    });
}

export function insightsOptions() {
    return queryOptions({
        queryKey: queryKeys.insights(),
        queryFn: ({ signal }) => practiceMemberApi.getInsights(signal),
        staleTime: Infinity,
    });
}

// A separate key from `me()` on purpose: `GET /practice-members/me` also backs the permission
// gate and the dashboard, so adding a license must not refetch those.
export function licensesOptions() {
    return queryOptions({
        queryKey: queryKeys.licenses(),
        queryFn: ({ signal }) => practiceMemberApi.getLicenses(signal),
    });
}
